var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConfirmModalDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 29,
    rx: 6.44444,
    fill: "#FFEDEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7363 11.8821L19.0033 19.2109C18.8924 20.3218 18.8375 20.8769 18.5844 21.2966C18.3624 21.6661 18.036 21.9616 17.6462 22.1458C17.2038 22.3543 16.647 22.3543 15.53 22.3543H13.4704C12.3543 22.3543 11.7966 22.3543 11.3542 22.1449C10.9641 21.9609 10.6374 21.6654 10.4152 21.2958C10.1638 20.8769 10.108 20.3218 9.99629 19.2109L9.26411 11.8821M15.8092 17.5546V13.1911M13.1912 17.5546V13.1911M7.95508 9.70039H11.9825M11.9825 9.70039L12.3194 7.36858C12.4171 6.94445 12.7697 6.646 13.1746 6.646H15.8258C16.2308 6.646 16.5824 6.94445 16.6811 7.36858L17.0179 9.70039M11.9825 9.70039H17.0179M17.0179 9.70039H21.0454",
    stroke: "#C10A0C",
    strokeWidth: 1.30903,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmModalDeleteIcon);
export default __webpack_public_path__ + "static/media/confirmModalDeleteIcon.f0fb00b17860b25dbee8514e2552e7b0.svg";
export { ForwardRef as ReactComponent };